import React from 'react';
import ReactDOM from 'react-dom';
import App from '@/App';

import { BrowserRouter } from "react-router-dom";

import '@/assets/css/index.less';
import './index.less';
import ErrorBoundary from './components/ErrorBoundary';
import Modal from 'react-modal';
import zhCN from 'antd/es/locale/zh_CN';
import { ConfigProvider } from 'antd';

import 'antd-mobile/es/global'
import VConsole from 'vconsole';
if((ENV !== 'prod' &&  (location.hostname !== 'localhost')|| location.search.indexOf('debug=') >= 0)){
   const vConsole = new VConsole();
}
try {
  const rootElement = document.getElementById('root');

  Modal.setAppElement(rootElement);

  const renderApp = () => {
    ReactDOM.render(
        <ConfigProvider locale={zhCN}>
            <React.StrictMode>
                <ErrorBoundary>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </ErrorBoundary>
            </React.StrictMode>
        </ConfigProvider>,
      document.getElementById('root'),
    );
  };
  renderApp();
} catch (e) {
  console.log('e');
}
